<template>
  <div class="loader">
    <img :src="src" alt="Laden…">
  </div>
</template>
<script>
export default {
  data() {
    return {
      src: frontend_dir + '/icons/HebladLoader.svg',
    }
  },
}
</script>
<style scoped>
.loader {
  display: block;
  width: 200px;
  margin: 150px auto;
}

.loader img {
  display: block;
  width: 100%;
  height: auto;
}
</style>
